import { render, staticRenderFns } from "./AudienceForm.vue?vue&type=template&id=28db29ba&scoped=true&"
import script from "./AudienceForm.vue?vue&type=script&lang=js&"
export * from "./AudienceForm.vue?vue&type=script&lang=js&"
import style0 from "./AudienceForm.vue?vue&type=style&index=0&id=28db29ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db29ba",
  null
  
)

export default component.exports